import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, watch, computed } from 'vue';
import { WeekDay, B2BDeliveryData } from '@/modules/Logistics/interfaces/LogisticsInterfaces';
import DeliveryRegionRepository from '@/repositories/DeliveryRegionRepository';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2BDeliverySection',
  props: {
    b2bDeliveryPhone: null,
    b2bDeliveryEmail: null,
    b2bDeliveryNotes: null,
    b2bDeliveryDays: null,
    languageCode: null,
    printRegion: null,
    languageOptions: null,
    internalCodeOptions: null,
    regionOptions: null,
    b2bDeliverySchedule: null,
    b2bDeliveryRegion: null,
    canAccessLogistics: { type: Boolean }
  },
  emits: ["b2b-delivery-change"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'b2b-delivery-change', payload: { isB2BDelivery: boolean; data: B2BDeliveryData }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    b2bDeliveryPhone?: string | null;
    b2bDeliveryEmail?: string | null;
    b2bDeliveryNotes?: string | null;
    b2bDeliveryDays?: string | string[] | null;
    languageCode?: string | null;
    printRegion?: string | null;
    languageOptions: Array<{ code: string; label: string }>;
    internalCodeOptions: Array<{ code: string; label: string }>;
    regionOptions: string[];
    b2bDeliverySchedule?: string | string[] | null;
    b2bDeliveryRegion?: string | null;
    canAccessLogistics: boolean;
};





const parseDeliveryDays = (value: string | string[] | null | undefined): string[] => {
    if (Array.isArray(value)) {
        return value;
    }

    return [];
};

const parseDeliverySchedule = (value: string | string[] | null | undefined): string => {
    if (typeof value === 'string') {
        return value;
    }
    if (Array.isArray(value) && value.length > 0) {
        return value[0];
    }
    return '';
};

const normalizedDeliveryDays = parseDeliveryDays(props.b2bDeliveryDays);

const isB2BDelivery = ref(false);

const b2bDeliveryData = reactive<B2BDeliveryData>({
    phoneNumber: props.b2bDeliveryPhone || '',
    email: props.b2bDeliveryEmail || '',
    notes: props.b2bDeliveryNotes || '',
    deliveryDays: normalizedDeliveryDays,
    languageCode: props.languageCode || '',
    printRegion: props.printRegion || '',
    deliverySchedule: parseDeliverySchedule(props.b2bDeliverySchedule),
    deliveryRegion: props.b2bDeliveryRegion || '',
});

const weekDays: WeekDay[] = [
    { key: 'monday', label: 'Monday' },
    { key: 'tuesday', label: 'Tuesday' },
    { key: 'wednesday', label: 'Wednesday' },
    { key: 'thursday', label: 'Thursday' },
    { key: 'friday', label: 'Friday' },
];

watch(
    () => props.languageCode,
    (newVal) => {
        b2bDeliveryData.languageCode = newVal ?? '';
    },
    { immediate: true },
);

watch(
    () => props.printRegion,
    (newVal) => {
        b2bDeliveryData.printRegion = newVal ?? '';
    },
    { immediate: true },
);

const emitChange = () => {
    emit('b2b-delivery-change', {
        isB2BDelivery: isB2BDelivery.value,
        data: {
            ...b2bDeliveryData,
            deliveryDays: [...b2bDeliveryData.deliveryDays],
        },
    });
};

const deliveryScheduleOptions = [
    { value: 'Dostva vsak drugi teden', label: 'Delivery every 2nd week' },
    { value: 'Drug urnik dostave', label: 'Other delivery schedule' },
];

const deliveryRegionOptions = computed(() => {
    return DeliveryRegionRepository.getAll();
});

const toggleDeliveryDay = (dayKey: string) => {
    const index = b2bDeliveryData.deliveryDays.indexOf(dayKey);
    if (index > -1) {
        b2bDeliveryData.deliveryDays.splice(index, 1);
    } else {
        b2bDeliveryData.deliveryDays.push(dayKey);
    }
    emitChange();
};

const toggleDeliverySchedule = (value: string) => {
    b2bDeliveryData.deliverySchedule = b2bDeliveryData.deliverySchedule === value ? '' : value;
    emitChange();
};

watch(
    () => [
        b2bDeliveryData.phoneNumber,
        b2bDeliveryData.email,
        b2bDeliveryData.notes,
        b2bDeliveryData.languageCode,
        b2bDeliveryData.printRegion,
        b2bDeliveryData.deliveryRegion,
    ],
    () => {
        emitChange();
    },
);

return { __sfc: true,props, emit, parseDeliveryDays, parseDeliverySchedule, normalizedDeliveryDays, isB2BDelivery, b2bDeliveryData, weekDays, emitChange, deliveryScheduleOptions, deliveryRegionOptions, toggleDeliveryDay, toggleDeliverySchedule }
}

})